export default __webpack_public_path__ + "static/media/house4.4df4dab6.jpg";